export default __webpack_public_path__ + "static/media/PLANSALUD2022_pasada_desktop_330x330-20220303-001202.b43f844e.png";